<template>
  <v-container class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Customers List</div>
        <div>
          <bread-crumb :bread-crumbs="['List of Customers']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <loading
          :active="isloadagents"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-form ref="filter">
          <v-row row-gutters class="mt-1 ma-2">
            <v-col cols="12" lg="3" sm="6" xs="12">
              <v-radio-group
                v-model="searchInputs.customer_type"
                row
                class="mt-0"
                justify-center
              >
                <v-radio label="Individual" value="IND"></v-radio>
                <v-radio label="Business" value="BUS"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" lg="3" sm="6" xs="12">
              <v-autocomplete
                attach
                :items="listOfFilters"
                v-model="userSelectedFilter"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="3" sm="6" xs="12" v-if="userSelectedFilter">
              <v-text-field
                v-if="userSelectedFilter === 'Customer ID'"
                placeholder="Enter Customer ID"
                v-model="searchInputs.customer_id"
                :rules="FieldRequired('Customer ID')"
                outlined
                dense
                :clearable="isFieldClearable('customer_id')"
              ></v-text-field>

              <v-text-field
                v-if="userSelectedFilter === 'Customer Name'"
                placeholder="Enter Customer Name"
                v-model="searchInputs.customer_name"
                :rules="FieldRequired('Customer Name')"
                autofocus
                outlined
                dense
                :clearable="isFieldClearable('customer_name')"
              ></v-text-field>

              <v-text-field
                v-if="userSelectedFilter === 'ID Number'"
                placeholder="Enter ID Number"
                v-model="searchInputs.id_number"
                :rules="FieldRequired('ID Number')"
                outlined
                dense
                :clearable="isFieldClearable('id_number')"
              ></v-text-field>

              <v-text-field
                v-if="userSelectedFilter === 'Email ID'"
                :rules="FieldRequired('Email ID')"
                placeholder="Enter Email"
                v-model="searchInputs.user_email"
                outlined
                dense
                :clearable="isFieldClearable('user_email')"
              ></v-text-field>
              <v-text-field
                v-if="userSelectedFilter === 'Phone Number'"
                placeholder="Enter Phone Number"
                :rules="FieldRequired('Phone Number')"
                v-model="searchInputs.phone_number"
                outlined
                dense
                :clearable="isFieldClearable('phone_number')"
              ></v-text-field>
            </v-col>

            <div class="d-flex">
              <div>
                <v-btn
                  depressed
                  small
                  class="mx-2 ms-3 primary text-capitalize"
                  @click="getRemitteList()"
                  @keyup.enter="getRemitteList"
                  >Get Results</v-btn
                >
              </div>
              <div>
                <v-btn
                  depressed
                  small
                  class="mx-2 text-capitalize"
                  outlined
                  color="primary"
                  @click="clear"
                  >Clear</v-btn
                >
              </div>
            </div>
          </v-row>
        </v-form>
        <v-row row-gutters class="mt-3">
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-col cols="12" lg="4" xs="12">
            <v-btn depressed color="primary" small @click="routeCustomer()"
              ><v-icon small class="me-1">mdi-account-plus</v-icon>Add
              {{ searchInputs.customer_type }} Customer
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records.Create customer using Add  Customer"
        item-key="user_id"
        dense
      >
        <template v-slot:item.user_type="{ item }">
          <v-chip
            label
            x-small
            outlined
            :color="item.user_type == 'Individual' ? 'primary' : 'secondary'"
          >
            {{ item.user_type }}
          </v-chip>
        </template>
        <template v-slot:item.name="{ item }">
          <a
            :class="
              item.user_type === 'Business' ? 'border-b width-anchor' : null
            "
            @click="
              item.user_type === 'Business'
                ? $router.push({
                    name: 'Customer Business',
                    query: {
                      login_id: item.login_id,
                      customer_id: item.customer_id,
                    },
                  })
                : null
            "
            >{{ item.name }}</a
          >
        </template>
        <template v-slot:item.Risk="{ item }">
          {{ getRiskLabel(item.Risk) }}
        </template>
        <template v-slot:item.no_of_beneficiary="{ item }">
          <v-chip
            small
            color="primary"
            @click="
              $router.push(
                `/BeneSummary?cust_id=${item.customer_id}&name=${item.name}`
              )
            "
          >
            {{ item.no_of_beneficiary ? item.no_of_beneficiary : 0 }}
          </v-chip>
        </template>
        <template v-slot:item.is_bus_complete_registered="{ item }">
          {{
            item.user_type == "Business" && !item.is_bus_complete_registered
              ? "In progress"
              : "Completed"
          }}
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-center align-center customer-actions">
            <v-btn
              @click="nextpage(item)"
              :disabled="item.account_status != 'Approved'"
              small
              class="text-capitalize"
              depressed
              color="primary"
            >
              <v-icon small title="View Details" class="">
                mdi-chevron-right
              </v-icon>
              Send Money
            </v-btn>
            <v-btn
              @click="openPasswordLinkDialog(item)"
              :disabled="(!item.mobile_number && !getPasswordLinkEmail(item)) || isSendingPasswordLink"
              small
              class="text-capitalize"
              depressed
              outlined
              color="primary"
            >
              <v-icon small class="me-1">mdi-link-variant</v-icon>
              Send link
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="passwordLinkDialog"
      :persistent="isSendingPasswordLink"
      max-width="480"
    >
      <v-card>
        <v-card-title>
          Send password setup link
          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="isSendingPasswordLink"
            aria-label="Close password setup dialog"
            @click="passwordLinkDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p v-if="passwordLinkCustomer">
            Choose how to send a password setup link to {{ passwordLinkCustomer.name }}.
          </p>
          <div v-if="passwordLinkCustomer">
            <p class="mb-2">Email: {{ getPasswordLinkEmail(passwordLinkCustomer) || 'Not available' }}</p>
            <p>Mobile number: {{ passwordLinkCustomer.mobile_number || 'Not available' }}</p>
          </div>
          <v-alert v-if="passwordLinkError" type="error" dense outlined role="alert">
            {{ passwordLinkError }}
          </v-alert>
          <v-alert v-if="passwordLinkResult" type="success" dense outlined role="status">
            {{ passwordLinkResult.message || 'Password setup link sent successfully.' }}
          </v-alert>
          <p
            v-for="(line, index) in passwordLinkResultLines"
            :key="index"
            class="password-link-response"
          >
            {{ line.before }}<a
              v-if="line.url"
              :href="line.url"
              target="_blank"
              rel="noopener noreferrer"
            >{{ line.url }}</a>{{ line.after }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            class="text-capitalize"
            :loading="isSendingPasswordLink && passwordLinkChannel === 'email'"
            :disabled="!getPasswordLinkEmail(passwordLinkCustomer) || isSendingPasswordLink"
            @click="sendPasswordLink('email')"
          >Email</v-btn>
          <v-btn
            color="primary"
            depressed
            class="text-capitalize"
            :loading="isSendingPasswordLink && passwordLinkChannel === 'mobile'"
            :disabled="!passwordLinkCustomer || !passwordLinkCustomer.mobile_number || isSendingPasswordLink"
            @click="sendPasswordLink('mobile')"
          >Mobile number</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import { FieldRequired } from "@/utils/validation.js";
import agentService from "@/services/agentService/AgentService.js";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Send Transaction",
  data: () => {
    return {
      itemsPerPage: "10",
      FieldRequired,
      headers: [
        { text: "Customer ID", value: "customer_id" },
        { text: "Customer Name", value: "name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: "Nationality", value: "nationality" },
        { text: "Phone Number", value: "mobile_number" },
        { text: "Email", value: "email_id" },
        { text: "Account Status", value: "account_status" },
        // { text: "Registration Status", value: "is_bus_complete_registered" },
        { text: "No of Beneciaries", value: "no_of_beneficiary" },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 280,
          align: "center",
        },
      ],
      userList: [],
      tatalcustomerslist: [],
      search: "",
      listOfFilters: [
        "Customer Name",
        "Customer ID",
        "ID Number",
        "Email ID",
        "Phone Number",
      ],
      searchInputs: {
        customer_type: "IND",
        // txn_from_date: new Date().toJSON().slice(0, 10),
        // txn_to_date: new Date().toJSON().slice(0, 10),
        // to_date: new Date().toJSON().slice(0, 10),
        // from_date: new Date().toJSON().slice(0, 10),
      },
      userSelectedFilter: "Customer Name",
      expanded: [],
      singleExpand: true,
      isloadagents: false,
      passwordLinkDialog: false,
      passwordLinkCustomer: null,
      isSendingPasswordLink: false,
      passwordLinkChannel: "",
      passwordLinkError: "",
      passwordLinkResult: null,
      skip: 0, // Initial skip value
      limit: 10000, // Initial limit value
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
    };
  },
  components: {
    BreadCrumb,
    // listOverviewVue
    Loading,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    passwordLinkResultLines() {
      const data = this.passwordLinkResult && this.passwordLinkResult.data;
      const lines = Array.isArray(data) ? data : typeof data === "string" ? [data] : [];
      return lines.filter(line => typeof line === "string").map(line => {
        const match = line.match(/https?:\/\/[^\s<>]+/);
        return match
          ? { before: line.slice(0, match.index), url: match[0], after: line.slice(match.index + match[0].length) }
          : { before: line, url: "", after: "" };
      });
    },
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },
  watch: {
    userSelectedFilter(val) {
      if (val === "Customer ID") {
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Customer Name") {
        this.searchInputs.customer_id = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "ID Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Email ID") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Phone Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
      } else {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      }
      this.$refs.filter.resetValidation();
    },
  },
  mounted() {
    if (this.isPreviousState) {
      const previousState = this.isPreviousState;
      this.searchInputs.customer_type =
        previousState.customer_type === "ALL"
          ? null
          : previousState.customer_type;
      this.searchInputs.customer_id = previousState.customer_id;
      this.searchInputs.customer_name = previousState.customer_name;
      this.searchInputs.id_number = previousState.id_number;
      this.searchInputs.user_email = previousState.user_email;
      this.searchInputs.phone_number = previousState.phone_number;
      this.searchInputs.account_status =
        previousState.account_status === "All"
          ? null
          : previousState.account_status;
      this.searchInputs.kyc_status =
        previousState.kyc_status === "ALL" ? null : previousState.kyc_status;
      this.searchInputs.from_date = previousState.from_date;
      this.searchInputs.to_date = previousState.to_date;
      this.searchInputs.txn_from_date = previousState.txn_from_date;
      this.searchInputs.txn_to_date = previousState.txn_to_date;
      this.getRemitteList();
    }
    console.log("queryery", this.$route.query.Totalcus_rejected);
    console.log(this.$store.state);
  },

  methods: {
    getPasswordLinkEmail(item) {
      return item && (item.email_id || item.user_email || item.email);
    },
    openPasswordLinkDialog(item) {
      if (this.isSendingPasswordLink) return;
      this.passwordLinkCustomer = item;
      this.passwordLinkError = "";
      this.passwordLinkChannel = "";
      this.passwordLinkResult = null;
      this.passwordLinkDialog = true;
    },
    async sendPasswordLink(channel) {
      if (this.isSendingPasswordLink) return;
      if (channel !== "email" && channel !== "mobile") return;
      const contact = channel === "email"
        ? this.getPasswordLinkEmail(this.passwordLinkCustomer)
        : this.passwordLinkCustomer && this.passwordLinkCustomer.mobile_number;
      if (!contact) {
        this.passwordLinkError = channel === "email"
          ? "This customer does not have an email address."
          : "This customer does not have a mobile number.";
        return;
      }
      this.isSendingPasswordLink = true;
      this.passwordLinkChannel = channel;
      this.passwordLinkError = "";
      this.passwordLinkResult = null;
      try {
        const response = channel === "email"
          ? await userService.sendCustomerPasswordEmailLink(contact)
          : await userService.sendCustomerPasswordLink(contact);
        const data = response && response.data;
        if (
          !response || response.status < 200 || response.status >= 300 ||
          (data && data.success === false) ||
          (data && data.status_code != null && (Number(data.status_code) < 200 || Number(data.status_code) >= 300))
        ) {
          throw new Error((data && data.message) || "Unable to send the password setup link. Please try again.");
        }
        this.passwordLinkResult = data || { message: "Password setup link sent successfully." };
      } catch (error) {
        const data = error && error.response ? error.response.data : error;
        this.passwordLinkError = (data && data.message) || "Unable to send the password setup link. Please try again.";
      } finally {
        this.isSendingPasswordLink = false;
      }
    },
    routeCustomer() {
      if (
        this.searchInputs.customer_type &&
        this.searchInputs.customer_type == "IND"
      ) {
        this.$router.push("/IndCustomer");
      } else if (
        this.searchInputs.customer_type &&
        this.searchInputs.customer_type == "BUS"
      ) {
        this.$router.push("/BusCustomer");
      }
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
    logComponentPath() {
      const currentPath = this.$route.path;
      console.log("Current Component Path:", currentPath);
    },
    validateFromDate(value) {
      if (value && this.searchInputs.to_date) {
        return (
          value <= this.searchInputs.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.searchInputs.from_date) {
        return (
          value >= this.searchInputs.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    validateFromTxnDate(value) {
      if (value && this.searchInputs.txn_to_date) {
        return (
          value <= this.searchInputs.txn_to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToTxnDate(value) {
      if (value && this.searchInputs.txn_from_date) {
        return (
          value >= this.searchInputs.txn_from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },

    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
      }
    },
    async getRemitteList() {
      const validate = this.$refs.filter.validate();
      if (validate) {
        this.isloadagents = true;
        console.log("rrr", this.searchInputs.customer_type);
        try {
          const params = {
            customer_type: this.searchInputs.customer_type
              ? this.searchInputs.customer_type
              : "ALL",
            customer_id: this.searchInputs.customer_id,
            customer_name: this.searchInputs.customer_name,
            id_number: this.searchInputs.id_number,
            user_email: this.searchInputs.user_email,
            phone_number: this.searchInputs.phone_number,
            from_date: this.searchInputs.from_date,
            to_date: this.searchInputs.to_date,
            skip: this.skip,
            limit: this.limit,
          };
          const response = await agentService.getCustomerList(params);
          if (response && response.status === 200) {
            this.isloadagents = false;
            this.userList = response.data.data;
            // to store the state of the page (handle page when route back )
            this.$store.dispatch("savePreviousPageState", {
              customer_type: this.searchInputs.customer_type
                ? this.searchInputs.customer_type
                : "ALL",
              customer_id: this.searchInputs.customer_id,
              customer_name: this.searchInputs.customer_name,
              id_number: this.searchInputs.id_number,
              user_email: this.searchInputs.user_email,
              phone_number: this.searchInputs.phone_number,
              account_status: this.searchInputs.account_status
                ? this.searchInputs.account_status
                : "All",
              kyc_status: this.searchInputs.kyc_status
                ? this.searchInputs.kyc_status
                : "ALL",
              from_date: this.searchInputs.from_date,
              to_date: this.searchInputs.to_date,
              txn_from_date: this.searchInputs.txn_from_date,
              txn_to_date: this.searchInputs.txn_to_date,
              skip: this.skip,
              limit: this.limit,
            });
          }
          // else if (response.status === 401) {
          //   this.getRemitteList();
          // }
          else {
            this.userList = [];
            this.isloadagents = true;
          }
        } catch (error) {
          this.isloadagents = true;
          console.error(error);
        }
      }
    },

    getRiskLabel(riskVal) {
      if (riskVal >= 0 && riskVal <= 50) {
        return "Low risk";
      } else if (riskVal > 50 && riskVal <= 80) {
        return "Medium risk";
      } else {
        return "High risk";
      }
    },
    nextpage(item) {
      console.log("data ", item);
      this.$router.push({
        name: "Transactions",

        query: {
          id: item.login_id,
          customerid: item.customer_id,
          user_type: item.user_type,
          user_type_code:
            item.user_type_code ||
            (item.user_type === "Individual" ? "IND" : "BUS"),
          name: item.name,
        },
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.customer-actions {
  gap: 8px;
  padding: 4px 0;
}
.password-link-response {
  overflow-wrap: anywhere;
}
</style>
